import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArtistPresenter from './ArtistPresenter';
import { useScrollTop } from '../../hooks';
import { artist as artistApi } from '../../api';

import ajm from '../../images/ajm/profile/1.webp';
import ghe from '../../images/ghe/profile/1.webp';
import jhs from '../../images/jhs/profile/1.webp';
import jns from '../../images/jns/profile/1.webp';
import krn from '../../images/krn/profile/krn-profile-05.webp';
import kbb from '../../images/kbb/profile/kbb-profile-03.webp';
import lsk from '../../images/lsk/profile/lsk-profile-01.webp';
import oskar from '../../images/oskar/profile/oskar-profile-02.webp';
import cwk from '../../images/cwk/profile/cwk-profile-01.webp';

import ajmCircle from '../../images/ajm/circle_profile/img-circle-02@3x.png';
import gheCircle from '../../images/ghe/circle_profile/img-circle-08@3x.png';
import jhsCircle from '../../images/jhs/circle_profile/img-circle-01@3x.png';
import jnsCircle from '../../images/jns/circle_profile/img-circle-07@3x.png';
import krnCircle from '../../images/krn/profile/krn-profile-04.webp';
import kbbCircle from '../../images/kbb/profile/kbb-profile-01.webp';
import lskCircle from '../../images/lsk/profile/lsk-profile-03.webp';
import oskarCircle from '../../images/oskar/profile/oskar-profile-01.webp';

const artistInitState = [
  { id: 'jhs', name: '정혜선', img: jhs, circle: jhsCircle },
  { id: 'ajm', name: '안재모', img: ajm, circle: ajmCircle },
  { id: 'lsk', name: '이수경', img: lsk, circle: lskCircle },
  { id: 'kbb', name: '김비비', img: kbb, circle: kbbCircle },
  { id: 'jns', name: '장남수', img: jns, circle: jnsCircle },
  { id: 'ghe', name: '길하은', img: ghe, circle: gheCircle },
  { id: 'krn', name: '김리나', img: krn, circle: krnCircle },
  { id: 'oskar', name: 'OSKAR KEEM', img: oskar, circle: oskarCircle },
  { id: 'cwk', name: '천우경', img: cwk, circle: cwk },
];

const ArtistContainer = () => {
  const [artist, setArtist] = React.useState(artistInitState);
  const navigate = useNavigate();

  const navigateToProfile = (id) => {
    navigate(`/artist/${id}`);
  }

  const getArtist = async () => {
    try {
      const response = await artistApi.getArtist();
      console.log('[getArtist] response.data : ', response.data);
      // setArtist(response.data.artist);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    // getArtist();
  }, []);
  
  useScrollTop();

  return <ArtistPresenter artist={artist} navigateToProfile={navigateToProfile} />;
};

export default ArtistContainer;
